/**
 * Created by satuk on 20.07.17.
 */
import React from "react";
import Divider from "material-ui/Divider";

const Footer = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 50, }}>
      <Divider/>
      e-store [created with react.js]
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js